import favoritesMutations from "./mutations.js";
import favoritesActions from "./actions.js";
import favoritesGetters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      favouritesArr: [],
    };
  },
  mutations: favoritesMutations,
  actions: favoritesActions,
  getters: favoritesGetters,
};
